import {
    Platform
} from "react-native";
import {
    createMMKV,
    type MMKV
} from "react-native-mmkv";

declare let window: {
    localStorage: {
        setItem: (key: string, value: string) => void;
        getItem: (key: string) => string | null;
        removeItem: (key: string) => void;
        clear: () => void;
    };
};

const createWebStorageMock = () => {
    return {
        set: (key: string, value: boolean | string | number | Uint8Array) => {
            window.localStorage.setItem(key, String(value));
        },
        getString: (key: string) => window.localStorage.getItem(key) || undefined,
        getNumber: (key: string) => {
            const val = window.localStorage.getItem(key);
            return val !== null ? Number(val) : undefined;
        },
        getBoolean: (key: string) => {
            const val = window.localStorage.getItem(key);
            if (val === "true") return true;
            if (val === "false") return false;
            return undefined;
        },
        contains: (key: string) => window.localStorage.getItem(key) !== null,
        delete: (key: string) => window.localStorage.removeItem(key),
        clearAll: () => window.localStorage.clear(),
        recrypt: () => {},
        addOnValueChangedListener: () => {
            return {
                remove: () => {}
            };
        }
    } as unknown as MMKV;
};
export const storage = Platform.OS === "web" ? createWebStorageMock() : createMMKV();
